<template>
    <svg width="187" height="55" viewBox="0 0 187 55" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_7576_2991)">
            <path d="M78.4707 34.1746V20.7688H109.278L99.0699 41.5375H108.657V54.8875H78.4707L88.679 34.1746H78.4707Z" fill="#00D572"/>
            <path d="M46.0564 34.1746V20.7688H76.2978L66.0896 41.5375H76.2978V54.8875H45.4355L55.6438 34.1746H46.0564Z" fill="#00D572"/>
            <path d="M41.3996 20.7688H26.498V54.8875H41.3996V20.7688Z" fill="#00D572"/>
            <path
                d="M30.1684 3.66288L24.562 16.5852C23.2472 15.637 21.8775 15.0606 20.1975 15.0606C17.6408 15.0606 15.5955 16.9571 15.5955 
                    20.5642V20.7687H23.302V34.0443H15.6138V54.8688H0V18.0355C0 7.21419 7.90732 0 17.7321 0C22.5167 0 26.936 1.6548 30.1684 3.66288Z"
                fill="#00D572"
            />
            <path d="M144.195 20.6758H111.214V34.0444H144.195V20.6758Z" fill="white"/>
            <path d="M134.279 21.2893H121.148V54.8688H134.279V21.2893Z" fill="white"/>
            <path d="M159.242 54.8874L146.751 21.2893H161.908L174.399 54.8874H159.242Z" fill="white"/>
            <path d="M174.491 54.8874L187 21.2893H171.843L159.352 54.8874H174.491Z" fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0_7576_2991">
                <rect width="187" height="54.8874" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>
